/* tslint:disable */
/* eslint-disable */
/**
 * Forecast-planning enum
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { ApiUtility } from '@codequality/vue-cli-base';
import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @enum {string}
 */

export enum E0円非表示フラグ {
    表示 = 0,
    非表示 = 1
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum ECF集計項目 {
    貸倒引当金 = '貸倒引当金',
    売上債権 = '売上債権',
    棚卸資産 = '棚卸資産',
    繰延資産 = '繰延資産',
    仕入債務 = '仕入債務',
    その他の流動資産 = 'その他の流動資産',
    その他の流動負債 = 'その他の流動負債',
    未払法人税等 = '未払法人税等',
    当期発生法人税等 = '当期発生法人税等',
    有価証券 = '有価証券',
    有形固定資産 = '有形固定資産',
    無形固定資産 = '無形固定資産',
    減価償却費 = '減価償却費',
    特別利益調整 = '特別利益調整',
    特別損失調整 = '特別損失調整',
    投資その他の資産 = '投資その他の資産',
    貸付金 = '貸付金',
    短期借入金 = '短期借入金',
    長期借入金 = '長期借入金',
    社債 = '社債',
    その他の固定負債 = 'その他の固定負債',
    資本金 = '資本金',
    自己株式 = '自己株式',
    配当金の支払額 = '配当金の支払額',
    受取利息及び受取配当金 = '受取利息及び受取配当金',
    支払利息等 = '支払利息等'
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum EOperator {
    addition = '+',
    subtraction = '-',
    multiplication = '×',
    division = '÷'
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum Eフェーズ種別 {
    分析フェーズ = 0,
    計画フェーズ = 1,
    モニタリングフェーズ = 2
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum Eフリーキャッシュフロー種別 {
    通常 = 0,
    CF計算書 = 1
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum Eモニタリング損益差異分析基準値 {
    年度合計 = 0,
    直近実績月 = 1
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum Eモニタリング業績予測基準値 {
    前期 = 0,
    計画 = 1
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum Eユーザー権限 {
    ユーザー = 0,
    管理者 = 1,
    担当者 = 2
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum E不動産種類 {
    土地 = '土地',
    建物 = '建物',
    借地権 = '借地権'
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum E借入金条件 {
    入金短期 = '借入金入金（短期借入金）',
    入金長期 = '借入金入金（長期借入金）',
    入金役員 = '借入金入金（役員借入金）',
    返済短期 = '借入金返済（短期借入金）',
    返済長期 = '借入金返済（長期借入金）',
    返済役員 = '借入金返済（役員借入金）'
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum E償却方法 {
    定額法 = '定額法',
    旧定額法 = '旧定額法',
    旧定率法 = '旧定率法',
    定率法250pct = '250%定率法',
    定率法200pct = '200%定率法',
    リース期間定額法 = 'リース期間定額法',
    定額法無形固定資産 = '定額法（無形固定資産）',
    一括償却資産 = '一括償却資産',
    任意償却 = '任意償却'
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum E償却項目 {
    資産コード = '資産コード',
    名称 = '名称',
    科目名 = '科目名',
    償却方法 = '償却方法',
    数量 = '数量',
    事業供用日 = '事業供用日',
    取得価額 = '取得価額',
    耐用年数 = '耐用年数',
    前期末簿価 = '前期末簿価',
    リース期間月数 = 'リース期間（月数）',
    残価保証額 = '残価保証額',
    勘定科目Pk = '勘定科目Pk'
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum E入力分類 {
    PLBSCF = 0,
    金融機関借入 = 1,
    役員借入 = 2,
    法人保有不動産 = 3,
    償却 = 4,
    実態BS = 5,
    科目別計画設定 = 6,
    返済計画 = 7,
    納税予測 = 8,
    資金繰り = 9,
    実態純資産 = 10,
    個人保有不動産 = 11,
    モニタリングPLBSCF = 12,
    OLDLOAN = 13,
    YEARCONFIG = 14
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum E分析非表示フラグ {
    表示 = 0,
    非表示 = 1
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum E勘定科目カテゴリ {
    貸借 = 0,
    損益 = 1,
    製造原価 = 2
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum E千円表示フラグ {
    円 = 0,
    千円 = 1
}


/**
 * -1:取込なし　はリクエストでのみ使用
 * @export
 * @enum {string}
 */

export enum E取込データ種別 {
    取込なし = -1,
    貸借対照表勘定式 = 0,
    貸借対照表報告式 = 1,
    損益計算書 = 2,
    販売費および一般管理費内訳書 = 3,
    製造原価報告書 = 4,
    固定資産台帳 = 5,
    月次貸借対照表 = 6,
    月次損益計算書 = 7,
    月次製造原価報告書 = 8,
    年次貸借対照表 = 9,
    年次損益計算書 = 10,
    年次製造原価報告書 = 11
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum E取込分類 {
    決算書 = 0,
    固定資産台帳 = 1,
    月次貸借対照表 = 2,
    月次損益計算書_月次製造原価報告書 = 3,
    実績月次貸借対照表 = 4,
    実績月次損益計算書_実績月次製造原価報告書 = 5,
    三表計画月次貸借対照表 = 6,
    三表計画月次損益計算書_三表計画月次製造原価報告書 = 7,
    三表計画年次貸借対照表 = 8,
    三表計画年次損益計算書_三表計画年次製造原価報告書 = 9
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum E取込形式 {
    pdf = 0,
    xlsx = 1
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum E回収支払条件 {
    回収0 = '当月回収',
    回収1 = '翌月回収',
    回収2 = '翌々月回収',
    回収3 = '3か月後回収',
    回収4 = '4か月後回収',
    回収5 = '5か月後回収',
    回収6 = '6か月後回収',
    支払0 = '当月支払',
    支払1 = '翌月支払',
    支払2 = '翌々月支払',
    支払3 = '3か月後支払',
    支払4 = '4か月後支払',
    支払5 = '5か月後支払',
    支払6 = '6か月後支払'
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum E固変区分 {
    固定費 = '固定費',
    変動費 = '変動費',
    棚卸増減 = '棚卸増減'
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum E帳票種別 {
    pdf = 'pdf',
    xlsx = 'xlsx'
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum E有無フラグ {
    なし = 0,
    あり = 1
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum E消費税区分 {
    免税事業者 = 0,
    課税事業者 = 1
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum E無効フラグ {
    有効 = 0,
    無効 = 1
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum E科目別計画明細ConfigType {
    直接入力 = 0,
    固定値 = 1,
    計算式 = 2,
    前年値月平均 = 3,
    前年同月値 = 4,
    前年値 = 5,
    科目選択 = 6
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum E科目別計画設定番号 {
    計画フェーズ = 0,
    モニタリングフェーズ = 1
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum E税区分 {
    課税売上 = '課税売上',
    課税売上返還 = '課税売上返還',
    輸出売上 = '輸出売上',
    輸出売上返還 = '輸出売上返還',
    その他売上 = 'その他売上',
    課税仕入 = '課税仕入',
    課税仕入返還 = '課税仕入返還',
    その他仕入 = 'その他仕入',
    対象外 = '対象外'
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum E端数処理 {
    切上げ = 0,
    切捨て = 1,
    四捨五入 = 2
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum E経理方式 {
    税抜経理 = 0,
    税込経理 = 1
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum E補助科目フラグ {
    通常 = 0,
    補助 = 1
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum E製造原価科目未使用フラグ {
    使用する = 0,
    使用しない = 1
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum E計画表示モード {
    月次計画第0期 = 0,
    月次計画第1期 = 1,
    年次計画 = 2
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum E課税方式 {
    本則課税 = 0,
    簡易課税 = 1
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum E資金繰りType {
    営業収入 = '営業収入',
    営業外収入 = '営業外収入',
    営業支出 = '営業支出',
    営業外支出 = '営業外支出',
    財務収入 = '財務収入',
    財務支出 = '財務支出'
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum E金融借入科目 {
    短期借入金 = '短期借入金',
    長期借入金 = '長期借入金'
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum E金融借入種別 {
    証書貸付 = '証書貸付',
    手形貸付 = '手形貸付',
    手形割引 = '手形割引',
    当座貸越 = '当座貸越',
    その他 = 'その他'
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum E金融借入返済方法 {
    元金均等 = '元金均等',
    元利均等 = '元利均等',
    その他 = 'その他'
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum E集計転記科目 {
    現金及び預金 = '現金及び預金',
    売上債権 = '売上債権',
    棚卸資産 = '棚卸資産',
    建物 = '建物',
    建物附属設備 = '建物附属設備',
    建物付属設備 = '建物付属設備',
    設備造作 = '設備造作',
    構築物 = '構築物',
    機械装置 = '機械装置',
    車両運搬具 = '車両運搬具',
    工具器具備品 = '工具器具備品',
    什器備品 = '什器備品',
    リース資産 = 'リース資産',
    一括償却資産 = '一括償却資産',
    減価償却累計額 = '減価償却累計額',
    土地 = '土地',
    電話加入権 = '電話加入権',
    借地権 = '借地権',
    ソフトウェア = 'ソフトウェア',
    投資有価証券 = '投資有価証券',
    関係会社株式 = '関係会社株式',
    敷金 = '敷金',
    差入保証金 = '差入保証金',
    保証金 = '保証金',
    保険積立金 = '保険積立金',
    配当金積立金 = '配当金積立金',
    長期前払費用 = '長期前払費用',
    長期貸付金 = '長期貸付金',
    預託金 = '預託金',
    出資金 = '出資金',
    リサイクル預託金 = 'リサイクル預託金',
    会員権 = '会員権',
    貸倒引当金投 = '貸倒引当金(投)',
    創立費 = '創立費',
    開業費 = '開業費',
    開発費 = '開発費',
    仕入債務 = '仕入債務',
    有利子負債短期借入金 = '有利子負債（短期借入金）',
    有利子負債長期借入金 = '有利子負債（長期借入金）',
    役員借入金 = '役員借入金',
    減価償却費販管費 = '減価償却費（販管費）',
    減価償却費製造原価 = '減価償却費（製造原価）',
    支払利息 = '支払利息',
    当期純利益 = '当期純利益',
    法人税等 = '法人税等',
    未払法人税等 = '未払法人税等',
    未払消費税等 = '未払消費税等',
    期末商品棚卸高 = '期末商品棚卸高',
    期末製品棚卸高 = '期末製品棚卸高',
    期末材料棚卸高 = '期末材料棚卸高',
    期末仕掛品棚卸高 = '期末仕掛品棚卸高',
    棚卸資産PL期末商品 = '棚卸資産（PL期末商品）',
    棚卸資産PL期末製品 = '棚卸資産（PL期末製品）',
    棚卸資産CR期末材料 = '棚卸資産（CR期末材料）',
    棚卸資産CR期末仕掛品 = '棚卸資産（CR期末仕掛品）'
}



/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * dummy path
         * @summary dummy path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dummyGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            let localVarPath = `/dummy`;
            if (process.env.VUE_APP_IS_MOCK === "true") localVarPath = ApiUtility.convertSampleUrl('GET', '/dummy', options);
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            // jsonファイルアクセス時、PUT/DELETEの場合apacheの仕様（default-handler）で弾かれてしまうため、GETへ変換している
            const method = process.env.VUE_APP_IS_MOCK === "true" && ['PUT', 'DELETE'].includes('GET')
              ? 'GET'
              : 'GET';
            const localVarRequestOptions = { method, ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * dummy path
         * @summary dummy path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dummyGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dummyGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * dummy path
         * @summary dummy path
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dummyGet(options?: any): AxiosPromise<void> {
            return localVarFp.dummyGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * dummy path
     * @summary dummy path
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public dummyGet(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).dummyGet(options).then((request) => request(this.axios, this.basePath));
    }
}


